// Helpers for building date range bounds sent to the API.
// The API treats DateFrom as inclusive and DateTo as exclusive, so a picked
// end day has to be sent as the start of the following day.

export const startOfDay = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

export const endOfDay = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

export const nextDayStart = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, 0, 0);
